export function filteredTab(data: TypeAny, status: string) {
  return data.filter(
    (selectedCuration: TypeAny) => selectedCuration && selectedCuration.status === status
  );
}
